// AI Agent Studio is a product label, so it uses the same quiet tag treatment
// as the other onboarding products. Selection belongs to the card/radio state;
// a blue tag here would make Studio look preselected.
export const StudioBadge = ({ label }: { label: string }) => (
  <span className="inline-flex h-5 shrink-0 items-center rounded-full border border-st2 bg-background px-2 font-jetbrains text-label uppercase text-muted-foreground">
    {label}
  </span>
)
